module.exports = __webpack_public_path__ + "img/SY.63c627a9.svg";